export default {
    baseUrl: process.env.SERVICES_URL || 'https://juris-demo-back.herokuapp.com',
    consultaTexto: 'consultaTexto'
}